import React, { useState, useEffect } from "react";
import { Navbar } from "../navbar/Navbar";
import { ProductCard } from "../tienda/ProductCard";
import { SearchBar } from "../tienda/SearchBar";
import { Cart } from "../tienda/Cart";
import { Slide } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { Tag } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";

import Aos from "aos";
import "aos/dist/aos.css";
import ScrollToTopButton from "../parallax/parallax-2/ScrollToTopButton";
import { Navbar2 } from "../navbar/Navbar2";
import { ProductCard2 } from "../tienda/ProductCard2";
import { Navbar3 } from "../navbar/Navbar3";
import { WavyContainer, WavyLink } from "react-wavy-transitions";

export const Tienda3PastasTextiles = () => {
  const [cart, setCart] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    Aos.init();
  }, []);

  const removeFromCart = (productId) => {
    const updatedCart = cart.filter((item) => item.id !== productId);
    setCart(updatedCart);
  };

  const { isOpen, onToggle, onClose } = useDisclosure();

  const handleCloseCart = () => {
    onClose(); // Cierra el carrito

    // También cambia el estado `showOverlay` cuando el carrito se cierra
    setShowOverlay(false);
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Recupera el carrito desde localStorage al cargar la página
    const data = window.localStorage.getItem("cart");
    if (data !== null) {
      setCart(JSON.parse(data));
    }
    setIsLoading(false); // <- Mueve esto aquí para indicar que la carga se ha completado
  }, []);

  useEffect(() => {
    // Guarda el carrito en localStorage cada vez que cambie
    window.localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  if (isLoading) {
    // You can render a loading indicator here if needed
    return <p>Loading...</p>;
  }

  return (
    <>
      <Navbar3 />

      {showOverlay && <div className="overlay"></div>}
      <div className="tienda" id="tienda3">
        <br></br>

        <div className="menu">
          <h1>Pastas Textiles - Cadence 📘</h1>

          <h3>
            Pastas textiles de la marca Cadence, ideales para proyectos de
            decoración y manualidades. Explora nuestra amplia gama de pastas
            para dar vida a tus creaciones.
          </h3>
        </div>

        <div className="marcas2">
          <WavyLink direction="up" to="/tienda/cadence/textil-cadence/pastas-textiles/fashion" color="#4593db">
            <div className="cadence-card">
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/xvm2wlq0uvt6jh3fk66be/pasta-textil-fashion-cadence.jpg?rlkey=0ijqh8rcrou7hqmnqfk9p1mut&st=8noxkluo&dl=0"
                alt="cadence"
              ></img>
              <br></br>
              <p>Pasta Textil FASHION Cadence</p>
            </div>
          </WavyLink>

          <WavyLink
            direction="up"
            to="/tienda/cadence/textil-cadence/pastas-textiles/fashion-metallic"
            color="#4593db"
          >
            <div className="cadence-card">
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/ywzshcmc0ivyahhf1c1rw/pasta-textil-fashion-metallic-cadence.jpg?rlkey=4tz40sqapukyaffbdjbwmix1g&st=sd9keijb&dl=0"
                alt="cadence"
              ></img>
              <br></br>
              <p>Pasta Textil FASHION METALLIC Cadence</p>
            </div>
          </WavyLink>

          <WavyLink
            direction="up"
            to="/tienda/cadence/textil-cadence/pastas-textiles/relieve-HI-LITE"
            color="#4593db"
          >
            <div className="cadence-card">
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/xlkg10hyp4ljps1w2rqq2/pasta-relieve-textil-hi-lite-cadence.jpg?rlkey=t9uzcev8b0wp92dp32mxnypj4&st=suiivzrj&dl=0"
                alt="cadence"
              ></img>
              <br></br>
              <p>Pasta Relieve Textil HI-LITE Cadence</p>
            </div>
          </WavyLink>

          <WavyLink
            direction="up"
            to="/tienda/cadence/textil-cadence/pastas-textiles/relieve-metallic"
            color="#4593db"
          >
            <div className="cadence-card">
              <img
                src="https://dl.dropboxusercontent.com/scl/fi/3ci0o19yk5nzqphstv2nz/pasta-relieve-textil-metallic-cadence.jpg?rlkey=ifglvn46gs5p69x5gutdysv8u&st=t3ovkh2f&dl=0"
                alt="cadence"
              ></img>
              <br></br>
              <p>Pasta Relieve Textil METALLIC Cadence</p>
            </div>
          </WavyLink>
          
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <Slide direction="bottom" in={isOpen} style={{ zIndex: 10 }}>
          <Box
            p="40px"
            color="white"
            mt="4"
            bg="teal.500"
            rounded="md"
            shadow="md"
          >
            <Cart
              cart={cart}
              setCart={setCart}
              removeFromCart={removeFromCart}
              handleCloseCart={handleCloseCart}
            />
          </Box>
        </Slide>

        <ScrollToTopButton />
      </div>
    </>
  );
};
